$(document).ready(function() {
  
  var shipping = {
    $container: document.querySelector(".js-production-time"),
    defaultShipping: "",
    getVariant: function() {
      return this.$container.dataset.variantId || null;
    },
    updateShipping: function(productionTimeObj) {
      const shippingStr = getProductionTimeStr(productionTimeObj);
  
      if (shippingStr) {
        this.$container.innerHTML = shippingStr + "&nbsp;";
      } else {
        this.$container.innerHTML = this.defaultShipping;
      }
    },
    setVariant(id) {
      this.$container.dataset.variantId = id;
    }
  };

  var getProductionTimeStr = function(productionTime, prepend = "", append = "") {
    if (!productionTime?.min && productionTime?.min !== 0) return "";

    if (productionTime.min === 0) {
      return "Instant or Scheduled Delivery";
    }

    if (prepend === "") prepend = "Ships within ";

    const { min, max } = productionTime;
    let scale = "business day";
    let hasMax = !!max;
    let tMin = min, tMax = max;
  
    const multiples = [ ["month", 20], ["week", 5] ];
  
    for (let i = 0; i < multiples.length; i++) {
      const [_scale, multiple] = multiples[i];
      let changed = false;

      let scaledMin = min / multiple;
      let scaledMax = max ? max / multiple : 0;
  
      if (scaledMin > 1.5) {
        if (hasMax && scaledMax > 1.5) {
          tMin = Math.ceil(scaledMin);
          tMax = Math.ceil(scaledMax);
          scale = _scale;
          changed = true;
        } else if (!hasMax) {
          tMin = Math.ceil(scaledMin);
          scale = _scale;
          changed = true;
        }
      }
  
      if (changed) break;
    }
  
    let s = `${tMin}`;
    if (hasMax) {
      s += ` - ${tMax}`;
    }
    if (hasMax || tMin > 1) {
      scale += "s";
    }
    s += ` ${scale}`;
  
    return prepend + s + append;
  }
  
  var getProductionDays = function() {
    var data = { min: 0, max: null };
  
    if (bwh) {
      if ("product_variants" in bwh) {
        var variantId = shipping.getVariant();
        if (
          variantId in bwh.product_variants &&
          bwh.product_variants[variantId].production_time
        ) {
          data = bwh.product_variants[variantId].production_time;
          return data;
        }
      }
      if (bwh.product && bwh.product.production_time) {
        data = bwh.product.production_time;
      }
      return data;
    }
  };

  shipping.updateShipping(getProductionDays());

  var updateFinalSaleElement = function(variant) {
    var productSkuList = $('#product-final-sale-container').text();
    var finalSaleCopy = $('#product-final-sale-copy').text();
    if (productSkuList.includes(variant.sku)) {
      $('#product-final-sale').text(finalSaleCopy)
    } else {
      $('#product-final-sale').text('')
    }
  };

  $("#ProductSection-product-template-8").on("variantChange", function(e) {
    var variant = e.variant;
    if(variant && "id" in variant) {
      shipping.setVariant(variant.id);
      var productionTimeObj = getProductionDays();
      shipping.updateShipping(productionTimeObj)
      updateFinalSaleElement(variant)
    }
  })
})
